import axiosInstance from './api';

export const getChatCompletion = async (messages, token) => {
  try {
    const response = await axiosInstance.post(
      '/chat/completion',
      messages,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (err) {
    console.error('Chat completion error:', {
      status: err.response?.status,
      data: err.response?.data,
      message: err.message,
    });
    let errorMessage = 'Failed to get chat response';
    if (err.response?.data?.detail) {
      errorMessage = Array.isArray(err.response.data.detail)
        ? err.response.data.detail.map((err) => err.msg).join('; ')
        : err.response.data.detail;
    }
    throw new Error(errorMessage);
  }
};

export const getIdeaComponents = async (ideaId, token) => {
  try {
    const response = await axiosInstance.get(`/chat/idea/${ideaId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    console.error('Get idea components error:', {
      status: err.response?.status,
      data: err.response?.data,
      message: err.message,
    });
    throw new Error(err.response?.data?.detail || 'Failed to fetch idea components');
  }
};

export const sendProjectChat = async (ideaId, prompt, token, chatHistory = []) => {
  try {
    const response = await axiosInstance.post(
      `/chat/project/${ideaId}`,
      { 
        prompt,
        chat_history: chatHistory
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (err) {
    console.error('Project chat error:', {
      status: err.response?.status,
      statusText: err.response?.statusText,
      data: err.response?.data,
      message: err.message,
      url: err.config?.url,
    });
    
    // Try to extract the most specific error message
    let errorMessage = 'Failed to send project chat';
    
    if (err.response?.data?.detail) {
      errorMessage = `Failed to send project chat: ${err.response.data.detail}`;
    } else if (err.response?.statusText) {
      errorMessage = `Failed to send project chat: ${err.response.status} ${err.response.statusText}`;
    } else if (err.message) {
      errorMessage = `Failed to send project chat: ${err.message}`;
    }
    
    throw new Error(errorMessage);
  }
};